import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const PaymentBreakdownCellRenderer = ({
  value: withHoldingStmntPartnerInfosSlim,
  data: form,
  context: { showPaymentBreakdownCallback }
}) => (
  <div className="form-action-btn-group">
    <span> { form.withHoldingStmntPartnerInfosSlim != null
      && form.withHoldingStmntPartnerInfosSlim.length > 0
      && <button
        className="btn btn-sm "
        onClick={ () => showPaymentBreakdownCallback(form) }
        type="button"
        title="Blended Rate Calculation"
      ><span className="icon icon-share" /></button> }
    </span>
  </div>
);

PaymentBreakdownCellRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.shape(),
  context: PropTypes.shape({
    showPaymentBreakdownCallback: PropTypes.func
  })
};

PaymentBreakdownCellRenderer.defaultProps = {
  context: {},
  value: [],
  data: {}
};
